// extracted by mini-css-extract-plugin
export default {"container":"NoData_container__HSIhq","image":"NoData_image__XWY4+","title":"NoData_title__oBN0r","empty":"NoData_empty__JoNNQ","clearAction":"NoData_clearAction__IseGq"};